import { readonly, ref } from "vue";
import { useMutationObserver } from "@vueuse/core";
// The legacy excerpt control panel is not a RecSidebar and publishes no inline extent; this class on <html> is its only open signal.
export const EXCERPT_MODE_CLASS = "rc-excerptMode";
const isExcerptModeOn = () => document.documentElement.classList.contains(EXCERPT_MODE_CLASS);
export const useExcerptPanelMode = () => {
    const isOpen = ref(isExcerptModeOn());
    useMutationObserver(document.documentElement, () => {
        isOpen.value = isExcerptModeOn();
    }, { attributes: true, attributeFilter: ["class"] });
    return { isOpen: readonly(isOpen) };
};
